import { IMeetingChangeset } from '../abstract-meeting-changeset';
import { IControlMeetingDetailsDTO } from '../../../api/control.dao';
import { IOperatorDetailsDTO } from '../../../api/rooms.dao';
import { MeetingRoomOperatorsEventBody } from '../index';

export class OperatorsRemovedFromTheMeetingRoom extends IMeetingChangeset<MeetingRoomOperatorsEventBody> {
    public applyChangesToMeeting(meeting: Partial<IControlMeetingDetailsDTO>): Partial<IControlMeetingDetailsDTO> {
        this.removeOperatorsFromMeetingRoom(meeting);
        return meeting;
    }

    public getMeetingRoomId(): number {
        return super.getChangeset().roomId;
    }

    private removeOperatorsFromMeetingRoom(meeting: Partial<IControlMeetingDetailsDTO>): void {
        meeting.room.operators = this.getOperatorIdsToRemove()
            .reduce(
                (operators, id) => this.removeOperatorById(operators, id),
                [...(meeting.room.operators || [])]
            );
    }

    private getOperatorIdsToRemove(): number[] {
        return super.getChangeset().operators.map(operator => operator.operatorId);
    }

    private removeOperatorById(operators: IOperatorDetailsDTO[], id: number): IOperatorDetailsDTO[] {
        const _operators = [...operators];
        const operatorIndex = _operators.findIndex(operator => operator.operatorId === id);

        if (operatorIndex !== -1) _operators.splice(operatorIndex, 1);

        return _operators;
    }
}
